module.exports = __webpack_public_path__ + "static/media/logo.2dfbb7b7.svg";